export enum EDeliveryPersonalRole {
  Citizen = 'citizen',
  TrustedRole = 'trustedRole',
}
